(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[369],{

/***/ 4693:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tag/[slug]",
      function () {
        return __webpack_require__(6250);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6498:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Used for wrapping elements in a conditional way.
 */ var ConditionalWrapper = function(param) {
    var condition = param.condition, wrapper = param.wrapper, children = param.children;
    return condition ? wrapper(children) : children;
};
/* harmony default export */ __webpack_exports__["Z"] = (ConditionalWrapper);


/***/ }),

/***/ 7867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ SecondNav; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_Atoms_CategoryBlock_CategoryBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3250);
/* harmony import */ var _utils_class_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5751);
/* harmony import */ var _utils_Slug__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1886);









/**
 * SecondNav Library Component
 */ var SecondNav = function(_param) {
    var className = _param.className, title = _param.title, isVertical = _param.isVertical, tabs = _param.tabs, categorySlug = _param.categorySlug, articleSlug = _param.articleSlug, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "title",
        "isVertical",
        "tabs",
        "categorySlug",
        "articleSlug"
    ]);
    var navStyles = (0,_utils_class_names__WEBPACK_IMPORTED_MODULE_3__/* .classMerge */ .q)("flex flex-col md:flex-row gap-4", "border-neutral-grey-70 border-b", className);
    var tabStyles = (0,_utils_class_names__WEBPACK_IMPORTED_MODULE_3__/* .classMerge */ .q)("font-display font-bold uppercase pb-3 whitespace-nowrap items-center", "text-body-5 md:text-body pb-2 text-neutral-grey-45", "border-y-2 border-transparent hover:text-vertical-primary");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        "data-cy": "SecondNav"
    }, props), {
        className: navStyles,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Atoms_CategoryBlock_CategoryBlock__WEBPACK_IMPORTED_MODULE_2__/* .CategoryBlock */ .X, {
                className: "mb-2 text-display-3 md:min-w-[300px]",
                hasBlock: isVertical,
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex overflow-x-auto gap-x-5 items-center pb-1 -mb-1 remove-scrollbar",
                children: tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: tab.name === "All" ? "/".concat((0,_utils_Slug__WEBPACK_IMPORTED_MODULE_7__/* .removeTrailingSlash */ .Qj)(categorySlug !== null && categorySlug !== void 0 ? categorySlug : "")) : "/".concat((0,_utils_Slug__WEBPACK_IMPORTED_MODULE_7__/* .removeTrailingSlash */ .Qj)(categorySlug !== null && categorySlug !== void 0 ? categorySlug : ""), "/").concat(tab.slug),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (0,_utils_class_names__WEBPACK_IMPORTED_MODULE_3__/* .classMerge */ .q)(tabStyles, "".concat(articleSlug === tab.slug || !articleSlug && tab.name === "All" ? "border-b-vertical-primary text-vertical-primary" : "")),
                            children: tab.name
                        })
                    }, tab.slug);
                })
            })
        ]
    }));
};
SecondNav.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    isVertical: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    onTabChange: prop_types__WEBPACK_IMPORTED_MODULE_8__.func,
    tabs: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.arrayOf)((0,prop_types__WEBPACK_IMPORTED_MODULE_8__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
        slug: prop_types__WEBPACK_IMPORTED_MODULE_8__.string
    }))
};


/***/ }),

/***/ 6009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ PostList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__(246);
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);
// EXTERNAL MODULE: ./src/components/Atoms/ConditionalWrapper/index.tsx
var ConditionalWrapper = __webpack_require__(6498);
// EXTERNAL MODULE: ./src/components/Atoms/Container/Container.tsx
var Container = __webpack_require__(1284);
// EXTERNAL MODULE: ./src/components/Molecules/Cards/NewsCard/NewsCard.tsx + 1 modules
var NewsCard = __webpack_require__(9517);
// EXTERNAL MODULE: ./src/components/Molecules/SectionHeader/SectionHeader.tsx
var SectionHeader = __webpack_require__(1312);
// EXTERNAL MODULE: ./src/components/Shared/Category.ts
var Category = __webpack_require__(5841);
;// CONCATENATED MODULE: ./src/components/Shared/Article.ts


var ArticlePropType = {
    verticalColor: (0,prop_types.shape)({
        primary: prop_types.string,
        secondary: prop_types.string
    }),
    img: (0,prop_types.shape)({
        src: prop_types.string,
        alt: prop_types.string
    }),
    alt: prop_types.string,
    label: prop_types.string,
    author: (0,prop_types.shape)({
        name: prop_types.string,
        username: prop_types.string
    }),
    duration: prop_types.string,
    timePublished: prop_types.string,
    heading: prop_types.string
};
var examplePost = {
    id: "12345",
    status: "published",
    img: {
        src: "/assets/images/example.jpg",
        cinematicSrc: "/assets/images/example.jpg",
        alt: "example image"
    },
    category: {
        name: "category",
        slug: "/"
    },
    vertical: {
        colors: {
            primary: Category/* ExampleColors.gaming */.L8.gaming,
            secondary: Category/* ExampleColors.gaming-secondary */.L8["gaming-secondary"]
        }
    },
    author: {
        name: "Joe Blogs",
        href: ""
    },
    duration: "2:22",
    timePublished: "0 mins ago",
    heading: "Title that spans over several lines but could do a lil more if you wanted",
    href: "/",
    isFeatured: false,
    description: ""
};

// EXTERNAL MODULE: ./src/hooks/useDeviceType.tsx
var useDeviceType = __webpack_require__(7890);
// EXTERNAL MODULE: ./src/templates/AdSidebar.tsx
var AdSidebar = __webpack_require__(3525);
// EXTERNAL MODULE: ./src/templates/SidebarAd/index.tsx
var SidebarAd = __webpack_require__(6486);
// EXTERNAL MODULE: ./src/utils/ads/getAdUnit/index.ts
var getAdUnit = __webpack_require__(8185);
// EXTERNAL MODULE: ./src/utils/class-names.ts + 11 modules
var class_names = __webpack_require__(5751);
;// CONCATENATED MODULE: ./src/utils/Cursor/Cursor.ts
/**
 * Function to set new cursor for infinite scroll.
 *
 * @param cursor The cursor to set.
 */ var setCursor = function(cursor) {
    var currentUrl = new URL(window === null || window === void 0 ? void 0 : window.location.href);
    var params = currentUrl.pathname.split("/").filter(function(param) {
        return param !== "";
    });
    window.history.replaceState({}, "", "".concat(currentUrl.origin, "/").concat(params[0], "/").concat(cursor));
};
/**
 * Function to delete cursor on the url param
 */ var deleteCursor = function() {
    var currentUrl = new URL(window === null || window === void 0 ? void 0 : window.location.href);
    var params = currentUrl.pathname.split("/").filter(function(param) {
        return param !== "";
    });
    if (params[1] !== undefined) {
        window.history.replaceState({}, "", "".concat(currentUrl.origin, "/").concat(params[0]));
    } else {
        return;
    }
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-in-viewport/dist/es/index.js
var es = __webpack_require__(9231);
;// CONCATENATED MODULE: ./src/components/Organisms/PostList/HiddenAnchor.tsx








var HiddenAnchor = function(_param) {
    var id = _param.id, href = _param.href, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "href",
        "className"
    ]);
    var anchorRef = (0,react.useRef)(null);
    (0,es/* useInViewport */.NM)(anchorRef, {
        threshold: 0.1
    }, {
        disconnectOnLeave: false
    }, {
        onEnterViewport: function() {
            if (!window) return;
            var anchor = anchorRef.current;
            if ((anchor === null || anchor === void 0 ? void 0 : anchor.id) !== "") {
                setCursor(anchor === null || anchor === void 0 ? void 0 : anchor.id);
            }
            if (!anchor) return;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        ref: anchorRef,
        id: id,
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            className: "w-full h-3"
        }))
    });
};
/* harmony default export */ var PostList_HiddenAnchor = (HiddenAnchor);

;// CONCATENATED MODULE: ./src/components/Organisms/PostList/PostList.tsx



















var cardStyles = (0,class_names/* classNames */.A)("col-span-1 pt-5 md:pt-0", "border-t-4 border-neutral-grey-4 md:border-0");
/**
 * PostList Library Component
 */ var PostList = function(_param) {
    var className = _param.className, title = _param.title, posts = _param.posts, hasMorePosts = _param.hasMorePosts, _articleType = _param.articleType, articleType = _articleType === void 0 ? "all" : _articleType, _isSidebarDisplayed = _param.isSidebarDisplayed, isSidebarDisplayed = _isSidebarDisplayed === void 0 ? false : _isSidebarDisplayed, _parentRef = _param.parentRef, parentRef = _parentRef === void 0 ? null : _parentRef, loadMore = _param.loadMore, level = _param.level, category = _param.category, isAuthorPostList = _param.isAuthorPostList, cursorList = _param.cursorList, lengthList = _param.lengthList, isCursor = _param.isCursor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "title",
        "posts",
        "hasMorePosts",
        "articleType",
        "isSidebarDisplayed",
        "parentRef",
        "loadMore",
        "level",
        "category",
        "isAuthorPostList",
        "cursorList",
        "lengthList",
        "isCursor"
    ]);
    var ref = (0,react.useState)([]), sidebarAdUnits = ref[0], setSidebarAdUnits = ref[1];
    var deviceType = (0,useDeviceType/* useDeviceType */.h)();
    var isDesktop = deviceType === "lg";
    (0,react.useEffect)(function() {
        if ((!category || !isSidebarDisplayed) && !isDesktop) {
            return;
        }
        var adPlacements = [];
        posts.forEach(function(_post, index) {
            var isAdPlacement = (index + 1) % 8 === 0;
            if (!isAdPlacement) {
                return;
            }
            var adPlacementIndex = (index + 1) / 8;
            var adPosition;
            switch(index){
                case 0:
                    adPosition = "top";
                    break;
                case posts.length - 1:
                    adPosition = "bottom";
                    break;
                default:
                    adPosition = "mid";
            }
            var sidebarAdUnit = (0,getAdUnit/* default */.Z)({
                pageType: "category",
                environment: "dweb",
                name: "skyscraper-".concat(adPosition, "-").concat(adPlacementIndex)
            });
            adPlacements.push(sidebarAdUnit);
        });
        setSidebarAdUnits(adPlacements);
    }, [
        posts,
        category,
        isSidebarDisplayed,
        isDesktop
    ]);
    (0,react.useEffect)(function() {
        if ((lengthList === null || lengthList === void 0 ? void 0 : lengthList.length) - 1 === (cursorList === null || cursorList === void 0 ? void 0 : cursorList.length)) {
            if ((cursorList === null || cursorList === void 0 ? void 0 : cursorList.length) === 0) {
                return;
            }
            var lastCursor = cursorList[cursorList.length - 1];
            setCursor(lastCursor);
        }
    }, [
        lengthList,
        cursorList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-cy": "PostList",
        className: (0,class_names/* classMerge */.q)("px-4 lg:px-0 text-title-5 lg:text-title-3 svg-filled", className)
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,class_names/* classMerge */.q)("col-span-full", isSidebarDisplayed && "md:col-span-8"),
                children: [
                    articleType === "all" && title && !isCursor && /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader/* SectionHeader */.M, {
                        className: "mb-8",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalWrapper/* default */.Z, {
                        condition: !isAuthorPostList,
                        wrapper: function(children) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((react_infinite_scroller_default()), {
                                loadMore: loadMore,
                                pageStart: 0,
                                hasMore: hasMorePosts,
                                useWindow: Boolean(!parentRef),
                                getScrollParent: function() {
                                    return parentRef;
                                },
                                children: children
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: posts === null || posts === void 0 ? void 0 : posts.map(function(article, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        (lengthList === null || lengthList === void 0 ? void 0 : lengthList.includes(index)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostList_HiddenAnchor, {
                                                id: cursorList === null || cursorList === void 0 ? void 0 : cursorList[lengthList.indexOf(index)],
                                                href: "".concat(category, "/").concat(cursorList === null || cursorList === void 0 ? void 0 : cursorList[lengthList.indexOf(index)])
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsCard/* NewsCard */.e, {
                                            level: level,
                                            className: (0,class_names/* classMerge */.q)(cardStyles, index === 3 && "md:hidden lg:grid", index === 0 && "border-t-0", "mb-6 md:mb-10"),
                                            post: article
                                        }, article.heading)
                                    ]
                                }, article.href);
                            })
                        })
                    })
                ]
            }),
            isSidebarDisplayed && category && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdSidebar/* Sidebar */.Y, {
                as: "div",
                children: sidebarAdUnits.map(function(adUnit) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarAd/* default */.Z, {
                        isSticky: true,
                        adUnit: adUnit,
                        className: "basis-full"
                    }, adUnit);
                })
            })
        ]
    }));
};
PostList.propTypes = {
    title: prop_types.string,
    posts: (0,prop_types.arrayOf)((0,prop_types.shape)(ArticlePropType)),
    hasMorePosts: prop_types.bool,
    loadMore: prop_types.func,
    articleType: prop_types.string,
    category: prop_types.string
};


/***/ }),

/***/ 8962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_GTM_pageview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7935);



/**
 * Hook to register GTM page views.
 */ var useGTMPageView = function() {
    var additionalParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        pageType: "page",
        author: "",
        vertical: "",
        category: "",
        wordCount: ""
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        (0,_utils_GTM_pageview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(router.asPath, "pageview", additionalParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
/* harmony default export */ __webpack_exports__["Z"] = (useGTMPageView);


/***/ }),

/***/ 6250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Atoms/Container/Container.tsx
var Container = __webpack_require__(1284);
// EXTERNAL MODULE: ./src/components/Molecules/SecondNav/SecondNav.tsx
var SecondNav = __webpack_require__(7867);
// EXTERNAL MODULE: ./src/components/Organisms/PostList/PostList.tsx + 3 modules
var PostList = __webpack_require__(6009);
// EXTERNAL MODULE: ./src/context/ads/AdsProvider.tsx + 6 modules
var AdsProvider = __webpack_require__(4150);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./src/hooks/useBackToArticle.tsx


/**
 * Checks if the prevUrl is an article page, if yes returns back to article page manually.
 */ var useBackToArticle = function() {
    var onBackButtonEvent = function(event) {
        event.preventDefault();
        var prevUrl = window.history.state.prevUrl;
        if (prevUrl) {
            router_default().push(window.history.state.prevUrl);
        } else {
            return;
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("popstate", onBackButtonEvent);
        return function() {
            window.removeEventListener("popstate", onBackButtonEvent);
        };
    }, []);
};

// EXTERNAL MODULE: ./src/hooks/useGTMPageView.tsx
var useGTMPageView = __webpack_require__(8962);
// EXTERNAL MODULE: ./src/templates/Main.tsx + 19 modules
var Main = __webpack_require__(1955);
// EXTERNAL MODULE: ./src/utils/getEnviroment.ts
var getEnviroment = __webpack_require__(5026);
// EXTERNAL MODULE: ./services/wordpress/index.ts + 27 modules
var wordpress = __webpack_require__(8625);
;// CONCATENATED MODULE: ./src/pages/tag/[slug].tsx














var TagPage = function(param) {
    var tag = param.tag, cursor = param.cursor, hasMorePosts = param.hasMorePosts;
    useBackToArticle();
    (0,useGTMPageView/* default */.Z)({
        pageType: "tag",
        author: "",
        category: "",
        vertical: ""
    });
    var setTargets = (0,react.useContext)(AdsProvider/* AdsContext */.$P).setTargets;
    var ref = (0,wordpress/* usePosts */.kx)({
        posts: tag.posts,
        tag: tag.slug,
        cursor: cursor,
        hasMorePosts: hasMorePosts
    }), getPosts = ref.getPosts, isLoading = ref.isLoading, hasMore = ref.hasMore, posts = ref.posts;
    (0,react.useEffect)(function() {
        var targets = {
            section: tag.slug,
            pageType: "tag",
            staging: !getEnviroment/* isProduction */.y
        };
        setTargets(targets);
    }, [
        setTargets,
        tag.slug
    ]);
    var seoProps = {
        titleTemplate: "%s",
        title: tag.seo.title || tag.name || "",
        canonical: tag.seo.canonical || "",
        description: tag.seo.description || "",
        openGraph: {
            url: tag.seo.openGraph.url || "",
            description: tag.seo.openGraph.description || ""
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col pt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seoProps)),
            tag.seo.schema && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    id: "tag-jsonld",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: tag.seo.schema
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-span-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondNav/* SecondNav */.j, {
                            className: "mx-4 mb-5 md:mb-10 lg:mx-0",
                            title: tag.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "font-body text-body-3 font-medium text-neutral-grey md:mb-5",
                            children: tag.seo.description
                        }),
                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Loading..."
                        }),
                        !isLoading && (posts === null || posts === void 0 ? void 0 : posts.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "No posts found."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostList/* PostList */.p, {
                level: "h2",
                isSidebarDisplayed: true,
                className: "px-4 lg:px-0",
                posts: posts,
                hasMorePosts: hasMore,
                loadMore: getPosts
            })
        ]
    });
};
TagPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Main/* Main */.o, {
        pageType: "tag",
        mainMenuItems: page.props.mainMenuItems,
        footerItems: page.props.footerItems,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (TagPage);


/***/ }),

/***/ 3525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Sidebar; },
/* harmony export */   "n": function() { return /* binding */ AdSidebar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _hooks_useDeviceType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7890);
/* harmony import */ var _utils_ads_getAdUnit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8185);
/* harmony import */ var _utils_class_names__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5751);
/* harmony import */ var _SidebarAd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6486);









var Sidebar = function(_param) {
    var className = _param.className, children = _param.children, tmp = _param.as, Tag = tmp === void 0 ? "aside" : tmp, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className",
        "children",
        "as"
    ]);
    var sidebarStyles = (0,_utils_class_names__WEBPACK_IMPORTED_MODULE_3__/* .classMerge */ .q)("hidden flex-col col-span-4 col-start-9 items-center h-full lg:flex", className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        "data-cy": "Sidebar"
    }, props), {
        className: sidebarStyles,
        children: children
    }));
};
/**
 * AdSidebar Library Component
 */ var AdSidebar = function(_param) {
    var className = _param.className, children = _param.children, _adPosition = _param.adPosition, adPosition = _adPosition === void 0 ? 1 : _adPosition, pageType = _param.pageType, as = _param.as, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className",
        "children",
        "adPosition",
        "pageType",
        "as"
    ]);
    var environment = "dweb";
    var deviceType = (0,_hooks_useDeviceType__WEBPACK_IMPORTED_MODULE_1__/* .useDeviceType */ .h)();
    var isDesktop = deviceType === "lg";
    if (!isDesktop) {
        return null;
    }
    var topId = "skyscraper-top-".concat(adPosition);
    var midId = "skyscraper-mid-".concat(adPosition);
    var topUnit = (0,_utils_ads_getAdUnit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        pageType: pageType,
        environment: environment,
        name: "skyscraper-top-1"
    });
    var midUnit = (0,_utils_ads_getAdUnit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        pageType: pageType,
        environment: environment,
        name: "skyscraper-mid-1"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Sidebar, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        as: as
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SidebarAd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                id: topId,
                isSticky: true,
                className: "h-[33%]",
                adUnit: topUnit
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SidebarAd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                id: midId,
                isSticky: true,
                className: "h-[67%]",
                adUnit: midUnit
            })
        ]
    }));
};
AdSidebar.propTypes = {
    as: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.oneOf)([
        "div",
        "aside"
    ]),
    pageType: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
    adPosition: prop_types__WEBPACK_IMPORTED_MODULE_8__.number
};


/***/ }),

/***/ 6486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Molecules_Ad__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9847);
/* harmony import */ var _utils_class_names__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5751);



var SidebarAd = function(param) {
    var adUnit = param.adUnit, className = param.className, isSticky = param.isSticky, _id = param.id, id = _id === void 0 ? adUnit : _id;
    var sizes = [
        [
            300,
            600
        ],
        [
            300,
            250
        ],
        [
            160,
            600
        ], 
    ];
    var sizeMapping = [
        {
            viewport: [
                0,
                0
            ],
            sizes: []
        },
        {
            viewport: [
                1200,
                0
            ],
            sizes: sizes
        }, 
    ];
    var adStyles = (0,_utils_class_names__WEBPACK_IMPORTED_MODULE_2__/* .classMerge */ .q)("w-full py-4 bg-neutral-grey-4 flex flex-col justify-center items-center", isSticky && "sticky top-10");
    var wrapperStyles = (0,_utils_class_names__WEBPACK_IMPORTED_MODULE_2__/* .classMerge */ .q)("w-full flex flex-col items-center", isSticky && "relative", className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: wrapperStyles,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: adStyles,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Molecules_Ad__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                id: id,
                adUnit: adUnit,
                sizes: sizes,
                sizeMapping: sizeMapping
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SidebarAd);


/***/ }),

/***/ 7935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6042);
/**
 * Trigger a page view for GTM.
 *
 * @param page THe url of the page.
 * @param event type of GTM event
 * @param additionalParams additional params to be sent to GTM
 * @param {object} additionalParams
 */ 
var pageview = function(page) {
    var event = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "pageview", additionalParams = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var ref;
    window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        event: event,
        page: page
    }, additionalParams));
};
/* harmony default export */ __webpack_exports__["Z"] = (pageview);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,747,340,955,152,774,888,179], function() { return __webpack_exec__(4693); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);